module.exports = "./img/e84529950e4b418b0202e9fa36390c03.jpg";